<template>
  <div style="padding: 5px">
    <div class="menu customer" style="margin-top: 0">
      <header>
        <h2 style="font-size: 1.5em">{{ $t('customer.title') }}</h2>
        <a-space>
          <a-button
            type="primary"
            @click="handleSearch"
            v-if="authorities.find(a => a.code === 'customer:query' || a.code === 'agent:customer:query')"
          >{{ $t('buttons.search') }}</a-button>
          <!--  @click="visible=true" -->
          <!-- @click="$router.push({ path: '/customer/detail' })" -->
          <a-button
            @click="$router.push({ path: '/customer/detail' })"
            type="primary"
            v-if="authorities.find(a => a.code === 'customer:insert' || a.code === 'agent:customer:insert')"
          >{{ $t('buttons.add') }}</a-button>
        </a-space>
      </header>
      <a-table
        :columns="columns"
        :data-source="data"
        :row-key="record => record.id"
        :pagination="pagination"
        :loading="isLoading"
        :scroll="scroll"
        @change="handleTableChange"
      >
        <template v-slot:company="text">
          <text-highlight :queries="[highLightInfo.company]">{{text}}</text-highlight>
        </template>
        <template v-slot:address="text">
          <text-highlight :queries="[highLightInfo.address]">{{text}}</text-highlight>
        </template>
        <template v-slot:username="text">
          <text-highlight :queries="[highLightInfo['userInfos.username']]">{{text}}</text-highlight>
        </template>
        <template v-slot:realName="text">
          <text-highlight :queries="[highLightInfo['userInfos.realName']]">{{text}}</text-highlight>
        </template>
        <template v-slot:organizationName="text">
          <text-highlight :queries="[highLightInfo['userInfos.organizationName']]">{{text}}</text-highlight>
        </template>
        <template v-slot:requiredCaptcha="text">{{ text ? '是' : '否' }}</template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">{{ text ? '是' : '否' }}</template>
        <template #operation="text, record">
          <a-button
            type="link"
            style="padding-left: 0"
            @click="$router.push({ path: '/customer/detail', query: { id: record.id } })"
            v-if="authorities.find(a => a.code === 'customer:update' || a.code === 'agent:customer:update')"
          >{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.yes')"
            :cancel-text="$t('common.no')"
            @confirm="removeCustomer(record.id)"
          >
            <a-button
              type="link"
              style="padding-left: 0"
              v-if="authorities.find(a => a.code === 'customer:delete')"
            >{{ $t('buttons.delete') }}</a-button>
          </a-popconfirm>
        </template>
      </a-table>
      <a-modal v-model="visible" :title="title" :width="990" @ok="submitForm" @cancel="clearForm">
        <a-form-model style="width: 300px" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="公司名称">
            <a-select
              show-search
              placeholder="请选择公司名称"
              v-model="form.company"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearchCompany"
              @blur="companyList = []"
              @change="handleChange"
            >
              <!-- <a-select
    mode="multiple"
    label-in-value
    :value="value"
    placeholder="Select users"
    style="width: 100%"
    :filter-option="false"
    :not-found-content="fetching ? undefined : null"
    @search="fetchUser"
    @change="handleChange"
              >-->
              <a-select-option v-for="d in companyList" :key="d.company">{{ d.company }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="联系方式">
            <a-input placeholder="请输入联系方式" v-model="form.mobile" />
          </a-form-model-item>
          <a-form-model-item label="联络人">
            <a-input placeholder="请输入联络人" v-model="form.contactPerson" />
          </a-form-model-item>
          <a-form-model-item label="省份">
            <a-input placeholder="请输入省份" v-model="form.province" />
          </a-form-model-item>
          <a-form-model-item label="城市">
            <a-input placeholder="请输入城市" v-model="form.city" />
          </a-form-model-item>
          <a-form-model-item label="区域">
            <a-input placeholder="请输入区域" v-model="form.area" />
          </a-form-model-item>
          <a-form-model-item label="公司地址">
            <a-input placeholder="请输入公司地址" v-model="form.address" />
          </a-form-model-item>
          <!-- <a-form-model-item label="用户">
            <a-select
              show-search
              v-model="form.userId"
              placeholder="搜索用户"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearchUser"
              @popupScroll="handlePopupScroll"
              @blur="handleBlur"
            >
              <a-select-option v-for="d in userList" :key="d.id">
                {{ d.realName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="销售员">
            <a-select
              show-search
              v-model="form.salesmanId"
              placeholder="搜索用户"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearchUser"
              @popupScroll="handlePopupScroll"
              @blur="handleBlur"
            >
              <a-select-option v-for="d in userList" :key="d.id">
                {{ d.realName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="服务员">
            <a-select
              show-search
              v-model="form.serviceManId"
              placeholder="搜索用户"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearchUser"
              @popupScroll="handlePopupScroll"
              @blur="handleBlur"
            >
              <a-select-option v-for="d in userList" :key="d.id">
                {{ d.realName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-button style="position: absolute; top: 705px; left: 90px;" type="primary" @click="addFollower">添加跟进人</a-button>
          <a-button :disabled="followers.length === 0" style="position: absolute; top: 705px; left: 200px;" @click="back">撤销</a-button>
          <a-form-model-item v-for="(follower, index) in followers" :key="index" :style="{ marginTop: index === 0 ? '50px' : ''}" :label="'跟进人' + (index + 1)">
            <a-select
              show-search
              v-model="follower.value"
              placeholder="搜索用户"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="handleSearchUser"
              @popupScroll="handlePopupScroll"
              @blur="handleBlur"
            >
              <a-select-option v-for="d in userList" :key="d.id">
                {{ d.realName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>-->
        </a-form-model>
        <div class="userList">
          <a-input
            @keyup.enter="handleSearchUserList"
            v-model="realName"
            style="position: absolute; width: calc(100% - 58px); top: 10px; left: 20px; z-index: 10"
            placeholder="请输入用户名"
          >
            <a-icon slot="suffix" type="search" style="color: rgba(0,0,0,.45); cursor: pointer" />
          </a-input>
          <div
            :key="isUsersLoading"
            @scroll="handleScroll"
            style="width: 100%; height: 100%; max-height: 448px; overflow: auto; border: 1px solid #ccc; padding: 10px; padding-top: 50px"
          >
            <draggable
              class="list-group stopdrop"
              tag="ul"
              v-model="list"
              v-bind="dragOptions1"
              :move="onMove"
              @start="handleStart"
              @end="isDragging = false"
            >
              <transition-group type="transition" :name="'flip-list'">
                <li
                  class="list-group-item"
                  v-for="element in list"
                  :key="element.order"
                >{{element.name}}</li>
              </transition-group>
            </draggable>
            <div v-show="isUserLoading" style="height: 30px; width: 100%; position: relative">
              <a-spin v-show="isUserLoading" key="spin" class="spin"></a-spin>
            </div>
          </div>
          <a-spin
            v-show="isUsersLoading"
            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
          ></a-spin>
        </div>
        <div class="resultList">
          <div
            style="width: 100%; height: 24%; max-height: 107px; border: 1px solid #ccc; overflow: auto; padding: 10px"
          >
            <h2>用户</h2>
            <draggable
              class="list-group 1"
              element="span"
              v-model="list2"
              v-bind="dragOptions"
              :move="onMove"
              @start="handleStart"
            >
              <transition-group name="no" class="list-group 1" tag="ul">
                <li class="list-group-item" v-for="(element, index) in list2" :key="element.order">
                  {{element.name}}
                  <a-icon type="close-circle" @click="removeElement(list2, index)" />
                </li>
              </transition-group>
            </draggable>
          </div>
          <div
            style="width: 100%; height: 24%; max-height: 107px; border: 1px solid #ccc; overflow: auto; padding: 10px"
          >
            <h2>销售员</h2>
            <draggable
              class="list-group 2"
              element="span"
              v-model="list3"
              v-bind="dragOptions"
              :move="onMove"
              @start="handleStart"
            >
              <transition-group name="no" class="list-group 2" tag="ul">
                <li class="list-group-item" v-for="(element, index) in list3" :key="element.order">
                  {{element.name}}
                  <a-icon type="close-circle" @click="removeElement(list3, index)" />
                </li>
              </transition-group>
            </draggable>
          </div>
          <div
            style="width: 100%; height: 24%; max-height: 107px; border: 1px solid #ccc; overflow: auto; padding: 10px"
          >
            <h2>服务员</h2>
            <draggable
              class="list-group 3"
              element="span"
              v-model="list4"
              v-bind="dragOptions"
              :move="onMove"
              @start="handleStart"
            >
              <transition-group name="no" class="list-group 3" tag="ul">
                <li class="list-group-item" v-for="(element, index) in list4" :key="element.order">
                  {{element.name}}
                  <a-icon type="close-circle" @click="removeElement(list4, index)" />
                </li>
              </transition-group>
            </draggable>
          </div>
          <div
            style="width: 100%; height: 24%; max-height: 107px; border: 1px solid #ccc; overflow: auto; padding: 10px"
          >
            <h2>跟进人</h2>
            <draggable
              class="list-group 4"
              element="span"
              v-model="list5"
              v-bind="dragOptions"
              :move="onMove"
              @start="handleStart"
            >
              <transition-group name="no" class="list-group 4" tag="ul">
                <li class="list-group-item" v-for="(element, index) in list5" :key="element.order">
                  {{element.name}}
                  <a-icon type="close-circle" @click="removeElement(list5, index)" />
                </li>
              </transition-group>
            </draggable>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import debounce from "@/components/function/debounce";
import moment from "moment";
import {
  searchCustomerList,
  getCustomerListByCompany,
  addCustomer,
  getCustomerById,
  updateCustomer,
  deleteCustomer
} from "@/api/customer";
import TextHighlight from "vue-text-highlight";

import { searchUserList, removeUser } from "@/api/auth/user";

const booleanMap = {
  是: true,
  否: false
};

const queryParams = {
  query: [
    {
      field: "realName",
      value: ""
    }
  ],
  filter: [],
  sort: []
};

export default {
  components: {
    TextHighlight
  },
  data() {
    return {
      data: [],
      authorities: [],
      isUserLoading: false,
      isUsersLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      visible: false,
      isLoading: false,
      roles: [],
      highLightInfo: {
        company: "",
        address: "",
        "userInfos.username": "",
        "userInfos.realName": "",
        "userInfos.organizationName": ""
      },
      organizations: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      pids: {
        0: "无"
      },
      sortInfo: [],
      searchInfo: {
        text: {
          protocolCode: "",
          protocolName: ""
        },
        column: {
          protocolCode: false,
          protocolName: false
        }
      },
      title: "新增客户",
      form: {
        company: undefined,
        address: "",
        mobile: "",
        contactPerson: "",
        province: "",
        city: "",
        area: "",
        lng: null,
        lat: null
      },
      requiredCaptcha: "",
      enabled: "",
      realName: "",
      t: true,
      columns: [
        {
          title: () => {return(
            <div>
              { this.$t('customer.company') }
              <span class="icons unset" style="cursor: pointer;" data-index="0">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                class="customerSearch"
                allow-clear
                type="text"
                data-index="0"
              />
            </div>
          )},
          dataIndex: "company",
          key: "company",
          scopedSlots: {
            customRender: "company"
          }
        },
        {
          title: () => {return(
            <div>
              { this.$t('customer.address') }
              <span class="icons unset" style="cursor: pointer;" data-index="1">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                class="customerSearch"
                type="text"
                allow-clear
                data-index="1"
              />
            </div>
          )},
          dataIndex: "address",
          key: "address",
          width: "20%",
          scopedSlots: {
            customRender: "address"
          }
        },
        // {
        //   title: (
        //     <div>
        //       用户账号
        //       <span class="icons unset" style="cursor: pointer;" data-index="2">
        //         <a-icon type="caret-up" />
        //         <a-icon type="caret-down" />
        //       </span>
        //       <a-input
        //         class="customerSearch"
        //         allow-clear
        //         type="text"
        //         data-index="2"
        //       />
        //     </div>
        //   ),
        //   dataIndex: "usernames",
        //   key: "userInfos.username",
        //   scopedSlots: {
        //     customRender: "username"
        //   }
        // },
        {
          title: () => {return(
            <div>
              { this.$t('customer.realName') }
              <span class="icons unset" style="cursor: pointer;" data-index="2">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                class="customerSearch"
                allow-clear
                type="text"
                data-index="2"
              />
            </div>
          )},
          dataIndex: "realNames",
          key: "userInfos.realName",
          scopedSlots: {
            customRender: "realName"
          }
        },
        {
          title: () => {return(
            <div>
              { this.$t('customer.organizationName') }
              <span class="icons unset" style="cursor: pointer;" data-index="3">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
              <a-input
                class="customerSearch"
                allow-clear
                type="text"
                data-index="3"
              />
            </div>
          )},
          dataIndex: "organizations",
          key: "userInfos.organizationName",
          scopedSlots: {
            customRender: "organizationName"
          }
        },
        {
          title: () => {return(
            <div>
              { this.$t('common.createdAt') }
              <span
                class="icons unset"
                style="cursor: pointer; right: -52px"
                data-index="4"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          )},
          dataIndex: "createdAt",
          key: "createdAt",
          width: 200
        },
        {
          title: () => {return(
            <div>
              { this.$t('common.updatedAt') }
              <span
                class="icons DESC"
                style="cursor: pointer; right: -52px"
                data-index="5"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          )},
          dataIndex: "updatedAt",
          key: "updatedAt",
          width: 200
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: "operation",
          key: "operation",
          align: "left",
          scopedSlots: { customRender: "operation" },
          fixed: 'right',
          width: 130
        }
      ],
      userList: [],
      companyList: [],
      followers: [],
      page: 1,
      user: "",
      list: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      moveMessageFlag: false,
      count: 0,
      userListPage: 1,
      authorities: [],
      scroll: {
        x: false
      }
    };
  },
  created() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
    this.queryParams = {
      query: [],
      filter: [],
      sort: [
        {
          field: "updatedAt",
          value: "DESC"
        }
      ]
    };
    this.searchString = "";
  },
  activated () {
    if (this.$store.state.customerFlag) {
      this.getCustomerList()
      this.$store.commit('setCustomerFlag', false)
    }
  },
  async mounted() {
    this.getCustomerList();
    this.f();
    const width = window.innerWidth
      if (width < 1600) {
        this.scroll.x = 1350
      } else if (width < 1900) {
        this.scroll.x = 1647
      } else {
        this.scroll.x = false
      }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    },
    dragOptions1() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
        group: { name: "description", pull: "clone" }
      };
    },
    listString() {
      return JSON.stringify(this.list, null, 2);
    },
    list2String() {
      return JSON.stringify(this.list2, null, 2);
    },
    lang: {
      get() {
        return this.$store.state.lang
      }
    }
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    lang(value) {
      console.log(this.columns);
    }
  },
  methods: {
    f() {
      const ss = document.querySelectorAll(
        ".ant-table-column-title > div span.icons"
      );
      ss.forEach(i => {
        i.addEventListener("click", () => {
          let c = "";
          switch (i.classList[1]) {
            case "ASC":
              c = "DESC";
              break;
            case "DESC":
              c = "unset";
              break;
            case "unset":
              c = "ASC";
              break;
            default:
              break;
          }
          i.classList.remove(i.classList[1]);
          i.classList.add(c);
          const ii = document.querySelectorAll(
            ".ant-table-column-title > div span.icons:not(.unset)"
          );
          const sort = Array.from(ii).map(item => {
            const index = +item.dataset["index"];
            console.log(item.classList);
            return {
              field: this.columns[index].key,
              value: item.classList[1]
            };
          });
          this.queryParams.sort = sort;
          this.searchCustomerList();
        });
      });
      this.ips = document.querySelectorAll(".customerSearch .ant-input");
        this.ips.forEach(ip => {
          ip.addEventListener("keyup", ({ key, target }) => {
            // console.log(key, target.value.trim())
            if (key === "Enter") {
              target.value = target.value.trim()
              // target.value.trim() && this.handleSearch()
              this.handleSearch();
            }
          });
          ip.addEventListener('blur', ({ target }) => {
            target.value = target.value.trim()
          })
        });
    },
    async getCustomerList() {
      this.searchCustomerList();
    },
    handleSearch() {
      this.pagination.current = 1;
      this.queryParams.filter = [];

      this.queryParams.query = [];
      this.ips.forEach(ip => {
        if (ip.value.trim()) {
          this.queryParams.query.push({
            field: this.columns[+ip.dataset["index"]].key,
            value: ip.value
          });
          this.highLightInfo[this.columns[+ip.dataset["index"]].key] = ip.value;
        } else {
          this.highLightInfo[this.columns[+ip.dataset["index"]].key] = "";
        }
      });
      this.searchCustomerList();
    },
    addFollower() {
      this.followers.push({
        value: ""
      });
    },
    back() {
      if (this.followers.at(-1)?.value === "") {
        this.followers.pop();
      } else {
        this.followers.at(-1).value = "";
      }
    },
    async handlePopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.page++;
        const { data } = await searchUserList(this.page, 10, queryParams);
        this.userList = this.userList.concat(data.records);
      }
    },
    async handleSearchUserList() {
      try {
        if (this.realName !== this.searchString) {
          this.userListPage = 1;
          this.searchString = this.realName;
          this.list = [];
          this.isUsersLoading = true;
        }
        const { data } = await searchUserList(this.userListPage, 20, {
          query: [
            {
              field: "realName",
              value: this.realName
            }
          ],
          filter: [],
          sort: []
        });
        this.userListTotalPage = data.pages;
        this.list = this.list.concat(
          data.records.map(item => {
            item.name = item.realName + " - " + item.username;
            (item.order = ++this.count), (item.fixed = false);
            return item;
          })
        );
      } catch (e) {
        console.log(e);
      } finally {
        this.isUserLoading = false;
        this.isUsersLoading = false;
      }
    },
    handleScroll({ target: { scrollHeight, scrollTop, clientHeight } }) {
      if (scrollHeight - scrollTop === clientHeight) {
        if (this.userListPage < this.userListTotalPage) {
          this.isUserLoading = true;
          this.userListPage++;
          this.handleSearchUserList();
        }
      }
    },
    handleSearchUser(value) {
      debounce(async () => {
        try {
          queryParams.query[0].value = value;
          const { data } = await searchUserList(this.page, 10, queryParams);
          data.records.forEach(d => {
            let s = d.realName;
            if (d.username) {
              s += " - " + d.username;
            }
            if (d.role) {
              s += " - " + d.role;
            }
            if (d.organization) {
              s += " - " + d.organization;
            }
            if (d.company) {
              s += " - " + d.company;
            }
            d.realName = s;
          });
          this.userList = data.records;
        } catch (e) {
          console.log(e);
        }
      }, 300);
    },
    handleSearchCompany(value) {
      debounce(async () => {
        try {
          const { data } = await getCustomerListByCompany(value);
          this.page = 1;
          this.companyList = data;
        } catch (e) {
          console.log(e);
        }
      }, 300);
    },
    handleBlur() {
      this.page = 1;
      this.userList = [];
      this.$forceUpdate();
    },
    setSelectOption(d) {
      let s = d.realName;
      if (d.username) {
        s += " - " + d.username;
      }
      if (d.role) {
        s += " - " + d.role;
      }
      if (d.organization) {
        s += " - " + d.organization;
      }
      if (d.company) {
        s += " - " + d.company;
      }
      return s;
    },
    handleUserChange(value) {
      this.form.userId = value;
      this.handleBlur();
    },
    handlesalesmanChange(value) {
      this.form.salesmanId = value;
      this.handleBlur();
    },
    handleserviceManChange(value) {
      this.form.serviceManId = value;
      this.handleBlur();
    },
    handleChange(value) {
      const item = this.companyList.find(c => c.company === value);
      if (item) {
        this.form.city = item.city;
        this.form.province = item.province;
        this.form.area = item.provincial;
      }
    },
    async searchCustomerList(callback) {
      this.isLoading = true;
      try {
        const { data } = await searchCustomerList(
          this.pagination.current,
          this.pagination.pageSize,
          this.queryParams
        );
        this.data = data.records.map(item => {
          item.usernames = {};
          item.realNames = {};
          item.organizations = {};
          (item.userInfos || []).forEach(u => {
            if (u.organizationName) {
              item.organizations[u.organizationName] = u.organizationName
            }
            if (u.realName) {
              item.realNames[u.realName] = u.realName
            }
            if (u.username) {
              item.usernames[u.username] = u.username
            }
          });
          item.organizations = Object.keys(item.organizations).join("，");
          item.realNames = Object.keys(item.realNames).join("，");
          item.usernames = Object.keys(item.usernames).join("，");
          item.createdAt = moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss");
          item.updatedAt = moment(item.updatedAt).format("YYYY-MM-DD HH:mm:ss");
          return item;
        });
        if (callback) {
          this.search = true;
          await callback();
          this.pagination.current = data.current;
          this.pagination.total = data.total;
        } else {
          this.pagination.current = data.current;
          this.pagination.total = data.total;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    async removeUser(record) {
      try {
        const { message } = await removeUser(record.id);
        this.$message.success(message);
        if (this.data.length === 1 && this.data[0].id === record.id) {
          this.pagination.current =
            this.pagination.current === 1 ? 1 : this.pagination.current - 1;
        }
        this.getCustomerList();
      } catch (e) {
        console.log(e);
        this.$message.error(this.$t('messages.ftd'));
      }
    },
    async submitForm() {
      try {
        const form = { ...this.form };
        form.users = this.list2.map(item => +item.id);
        form.salesmen = this.list3.map(item => +item.id);
        form.serviceMans = this.list4.map(item => +item.id);
        form.followers = this.list5.map(item => +item.id);
        if (this.form.id) {
          const { message } = await updateCustomer(form);
          this.$message.success(message);
        } else {
          const { message } = await addCustomer(form);
          this.$message.success(message);
        }
        this.getCustomerList();
        this.visible = false;
        this.clearForm();
      } catch (e) {
        console.log(e);
      }
    },
    async showEditModal(record) {
      this.title = "编辑用户";
      const { data } = await getCustomerById(record.id);
      this.list2 = (data.users || []).map(item => {
        item.name = item.realName + " - " + item.username;
        (item.order = ++this.count), (item.fixed = false);
        return item;
      });
      this.list3 = (data.salesmen || []).map(item => {
        item.name = item.realName + " - " + item.username;
        (item.order = ++this.count), (item.fixed = false);
        return item;
      });
      this.list4 = (data.serviceMans || []).map(item => {
        item.name = item.realName + " - " + item.username;
        (item.order = ++this.count), (item.fixed = false);
        return item;
      });
      this.list5 = (data.followers || []).map(item => {
        item.name = item.realName + " - " + item.username;
        (item.order = ++this.count), (item.fixed = false);
        return item;
      });
      // this.userList = data.followers.concat(data.salesmen).concat(data.serviceMans).concat(data.users)
      // console.log(this.userList);
      for (let key in this.form) {
        this.form[key] = data[key];
      }
      this.form.id = record.id;
      // this.followers = [];
      // (data.followers || []).forEach(item => {
      //   if(item) {
      //     this.followers.push({ value: item && item.id})
      //   }
      // })
      // this.form.id = record.id
      this.visible = true;
    },
    clearForm() {
      this.form = {
        company: "",
        address: "",
        mobile: "",
        contactPerson: "",
        province: "",
        city: "",
        area: "",
        lng: null,
        lat: null
      };
      this.list = [];
      this.list2 = [];
      this.list3 = [];
      this.list4 = [];
      this.list5 = [];
      this.realName = "";
      this.count = 0;
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.searchCustomerList();
    },
    orderList() {
      console.log("order");
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      console.log("onMove");
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      if (
        relatedContext.component.$el &&
        Array.from(relatedContext.component.$el.classList).includes("stopdrop")
      ) {
        return false;
      }
      if (
        relatedContext.component.$el.className !== this.className &&
        relatedContext.list.find(
          item => item.name === draggedContext.element.name
        )
      ) {
        if (this.moveMessageFlag) {
          this.$message.warn(draggedContext.element.name + "已存在");
          this.moveMessageFlag = false;
        }
        return false;
      }
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    handleStart(e) {
      console.log(e.from.className);
      this.moveMessageFlag = true;
      this.className = e.from.className;
    },
    removeElement(data, i) {
      data.splice(i, 1);
    },
    async removeCustomer(id) {
      try {
        const { message } = await deleteCustomer(id)
        this.$message.success(message)
        this.getCustomerList()
      } catch(e) {
        console.log(e)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.menu {
  margin: 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
/deep/.ant-modal-body {
  display: flex;
  justify-content: space-between;
}
.userList {
  width: 300px;
  padding: 0 10px;
  position: relative;
}
.resultList {
  padding: 0 10px;
  padding-left: 0;
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h2 {
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
}
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  margin-bottom: 0;
  position: relative;
}

.list-group-item {
  cursor: move;
  position: relative;
}

.list-group-item i {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.col-md-3 {
  border: 1px solid #ccc;
}
.spin {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 10px;
}
</style>